// Dodawanie wpisów: okno „Nowy wpis", pola typów, menu „+" i dyktowanie (AI).
export default {
    types: {
        meal: { label: 'Posiłek', title: 'Nowy posiłek', editTitle: 'Edytuj posiłek' },
        sleep: { label: 'Sen', title: 'Nowy wpis snu', editTitle: 'Edytuj sen' },
        task: { label: 'Zadanie', title: 'Nowe zadanie', editTitle: 'Edytuj zadanie' },
        event: { label: 'Wydarzenie', title: 'Nowe wydarzenie', editTitle: 'Edytuj wydarzenie' },
        note: { label: 'Notatka', title: 'Nowa notatka', editTitle: 'Edytuj notatkę' },
        report: { label: 'Wpis dnia', title: 'Nowy wpis dnia', editTitle: 'Edytuj wpis dnia' },
        workout: { label: 'Trening', title: 'Nowy trening', editTitle: 'Edytuj trening' },
    },
    validation: {
        nameRequired: 'Nazwa jest wymagana',
        timeRequired: 'Godzina jest wymagana',
        workoutTypeRequired: 'Wybierz rodzaj treningu',
        doneWorkoutDuration: 'Wykonany trening potrzebuje czasu trwania',
        doneWorkoutCalories: 'Wykonany trening potrzebuje kalorii',
        sleepTimeRequired: 'Podaj godzinę zaśnięcia albo pobudki',
        qualityRange: 'Jakość to liczba od 1 do 100',
        napTimes: 'Każda drzemka potrzebuje godziny początku i końca',
        taskTextRequired: 'Treść zadania jest wymagana',
        taskTimeRequired: 'Podaj godzinę albo wyłącz godzinę',
        weekdayRequired: 'Wybierz przynajmniej jeden dzień tygodnia',
        recurringNeedsDay: 'Zadanie cykliczne potrzebuje dnia, od którego się zaczyna',
        noteContentRequired: 'Wpisz treść albo tytuł',
        eventTitleRequired: 'Nazwa wydarzenia jest wymagana',
        endBeforeStart: 'Koniec nie może być przed początkiem',
        startTimeRequired: 'Podaj godzinę początku',
        endTimeRequired: 'Podaj godzinę końca',
        reportContentRequired: 'Wpisz treść wpisu',
    },
    dialog: {
        close: 'Zamknij',
        delete: 'Usuń',
        cancel: 'Anuluj',
        saving: 'Zapisuję…',
        save: 'Zapisz',
        saveChanges: 'Zapisz zmiany',
        checkData: 'Sprawdź wpisane dane.',
        tasksUnsupported: 'To API nie obsługuje jeszcze zadań.',
        saveFailed: 'Nie udało się zapisać. Spróbuj ponownie.',
        deleteFailed: 'Nie udało się usunąć wpisu.',
        deleteTitle: 'Usunąć ten wpis ({type})?',
        deleteLinkedEventMessage: 'Wydarzenie zniknie z osi dnia i z Google Calendar (przy włączonej synchronizacji). Tego nie da się cofnąć.',
        deleteMessage: 'Wpis zniknie z osi dnia. Tego nie da się cofnąć.',
    },
    fab: {
        menuHeading: 'DODAJ DO {day}',
        addTo: 'Dodaj do {day}',
        close: 'Zamknij',
        typeSentence: 'Wpisz zdaniem…',
        shortcuts: { meal: 'P', sleep: 'S', task: 'Z', event: 'K', note: 'N', workout: 'T', report: 'W' },
    },
    fields: {
        time: 'Godzina',
    },
    daySelect: {
        label: 'Dzień',
        today: 'dzisiaj',
        yesterday: 'wczoraj',
        tomorrow: 'jutro',
        search: 'Szukaj dnia…',
    },
    when: {
        optional: '— opcjonalna',
        setTime: 'Nadaj godzinę',
        past: 'wstecz',
        noTime: 'Bez godziny',
    },
    event: {
        pinnedPlaces: 'Przypięte',
        otherPlaces: 'Pozostałe',
        myPlaces: 'Moje miejsca',
        titlePlaceholder: 'Co się dzieje? np. Fryzjer',
        allDay: 'Cały dzień',
        firstDay: 'Pierwszy dzień',
        start: 'Początek',
        lastDay: 'Ostatni dzień',
        end: 'Koniec',
        location: 'Miejsce',
        locationPlaceholder: 'Adres, nazwa albo link z Google Maps — opcjonalne',
        pickPlace: 'Wybierz z zapisanych miejsc',
        searchPlace: 'Szukaj miejsca…',
        description: 'Opis',
        descriptionPlaceholder: 'Szczegóły — opcjonalne',
        recurringInfo: 'To wystąpienie serii z Google Calendar — zmiana i usunięcie dotyczą tylko tego dnia.',
        linkedPending: 'Powiązane z Google Calendar — zmiana czeka na wysłanie.',
        linked: 'Powiązane z Google Calendar.',
    },
    ingredients: {
        heading: 'SKŁAD',
        nameRequired: 'Podaj nazwę składnika.',
        weightPositive: 'Waga musi być większa od zera.',
        codeNotFound: 'Kodu {code} nie ma w Open Food Facts — wpisz produkt ręcznie.',
        codeCheckFailed: 'Nie udało się sprawdzić kodu. Spróbuj ponownie.',
        weightOf: 'Waga składnika {name}',
        remove: 'Usuń {name}',
        empty: 'Brak składników — dodaj pierwszy poniżej.',
        ingredient: 'Składnik',
        searchPlaceholder: 'Szukaj w katalogu albo wpisz swoją nazwę',
        amount: 'Ilość',
        scan: 'Skanuj kod kreskowy produktu',
        add: 'Dodaj',
        checkingCode: 'Sprawdzam kod…',
        hint: 'Produkt z katalogu wnosi swoje makra; nazwa spoza katalogu dodaje pozycję bez wartości.',
        total: 'Razem {kcal} kcal · {grams} g',
    },
    meal: {
        nutrients: {
            calories: 'Kalorie',
            protein: 'Białko',
            carbs: 'Węgle',
            fat: 'Tłuszcze',
            saturated_fat: 'Nasycone',
            sugar: 'Cukry',
            fiber: 'Błonnik',
            salt: 'Sól',
        },
        fromSaved: 'Z zapisanych posiłków',
        manualEntry: 'Wpisuję ręcznie',
        searchMeal: 'Szukaj posiłku…',
        singleProduct: 'Albo pojedynczy produkt',
        searchProduct: 'Szukaj produktu',
        weightGrams: 'Waga g',
        namePlaceholder: 'Co jesz? np. owsianka z borówkami',
        status: 'Status',
        eaten: 'Zjedzony',
        planned: 'Zaplanowany',
        editIngredients: 'Edytuj skład posiłku',
        addIngredients: 'Dodaj skład posiłku',
        valuesFromIngredients: 'WARTOŚCI ZE SKŁADU',
        nutritionValues: 'WARTOŚCI ODŻYWCZE',
        enterMacrosManually: 'Wpisz makra ręcznie',
        price: 'Cena',
        computedHint: 'Liczone ze składu — API przeliczy je ponownie po zapisie.',
    },
    naps: {
        heading: 'DRZEMKI',
        total: 'Razem {total}',
        startOf: 'Początek drzemki {n}',
        endOf: 'Koniec drzemki {n}',
        qualityPlaceholder: 'jakość',
        qualityOf: 'Jakość drzemki {n}',
        notePlaceholder: 'notatka',
        noteOf: 'Notatka drzemki {n}',
        remove: 'Usuń drzemkę {n}',
        empty: 'Bez drzemek tego dnia.',
        add: 'Dodaj drzemkę',
    },
    note: {
        titlePlaceholder: 'Tytuł — opcjonalny',
        contentPlaceholder: 'Co chcesz zapamiętać?',
    },
    report: {
        contentPlaceholder: 'Co się właśnie stało?',
    },
    sleep: {
        wakeDay: 'Dzień pobudki',
        bedtime: 'Zaśnięcie',
        bedtimePlaceholder: 'np. 23',
        wakeUp: 'Pobudka',
        wakeUpPlaceholder: 'np. 7',
        noWakeUp: 'Bez pobudki wpis zostaje niedokończony — dopiszesz ją rano.',
        noBedtime: 'Bez zaśnięcia wpis zostaje niedokończony.',
        quality: 'Jakość',
        notes: 'Notatki',
        notesPlaceholder: {
            male: 'Jak spałeś? Co przeszkadzało?',
            female: 'Jak spałaś? Co przeszkadzało?',
        },
    },
    task: {
        textPlaceholder: 'Co trzeba zrobić?',
        noDayInfo: 'Bez dnia — zadanie czeka w „Do rozplanowania”, aż wskażesz mu dzień.',
        noDayToggle: 'Jeszcze nie wiem kiedy — do rozplanowania',
        reminder: 'Przypomnienie',
        repeat: 'Powtarzaj',
        weekdays: 'Dni tygodnia',
        every: 'co',
        interval: 'Co ile',
        // Po polsku zawsze dopełniacz liczby mnogiej („co 1 dni" — tak jak dotąd).
        intervalUnit: {
            daily: 'dni | dni | dni',
            weekly: 'tygodni | tygodni | tygodni',
            monthly: 'miesięcy | miesięcy | miesięcy',
        },
        repeatSummary: '{summary} — odhaczone zostaje w tym dniu, a zadanie przechodzi na następny.',
        project: 'Projekt',
        untitledProject: 'Projekt bez tytułu',
        noProject: 'Bez projektu — osobne zadanie',
        searchProject: 'Szukaj projektu…',
    },
    workout: {
        fallbackName: 'Trening',
        repeat: 'Powtórz trening',
        fromScratch: 'Wpisuję od nowa',
        searchWorkout: 'Szukaj treningu…',
        type: 'Rodzaj treningu',
        pickType: 'Wybierz rodzaj',
        searchType: 'Szukaj rodzaju…',
        noTypes: 'Nie masz jeszcze rodzajów treningu — dodaj je w Treningi → Rodzaje treningów.',
        start: 'Start',
        status: 'Status',
        done: 'Wykonany',
        planned: 'Zaplanowany',
        plannedHint: 'Czas i kalorie uzupełnisz, gdy trening się odbędzie.',
        duration: 'Czas',
        hoursUnit: 'godz.',
        minutesUnit: 'min.',
        calories: 'Kalorie',
        distance: 'Dystans',
    },
    voice: {
        errors: {
            silence: 'Nic nie słyszę — sprawdź, który mikrofon wybrała przeglądarka.',
            noAccess: 'Brak dostępu do mikrofonu — zezwól na niego w przeglądarce.',
            noMic: 'Przeglądarka nie widzi mikrofonu — sprawdź, który jest wybrany.',
            micBusy: 'Mikrofon jest zajęty przez inną aplikację.',
            network: 'Rozpoznawanie mowy wymaga internetu.',
            micError: 'Błąd mikrofonu ({code}).',
            noSpeech: 'Nie rozpoznano mowy w nagraniu — spróbuj jeszcze raz.',
            recordingInvalid: 'Nagranie jest puste albo za długie.',
            transcribeService: 'Błąd usługi rozpoznawania mowy — spróbuj ponownie.',
            transcribeNotConfigured: 'Rozpoznawanie mowy nie jest skonfigurowane.',
            recordingSendFailed: 'Nie udało się wysłać nagrania.',
            notRecognized: 'Nie rozpoznano treści wpisu.',
            emptyEntry: 'Wpis jest pusty.',
            aiService: 'Błąd usługi AI — spróbuj ponownie.',
            aiNotConfigured: 'Usługa AI nie jest skonfigurowana.',
            sendFailed: 'Nie udało się wysłać wpisu.',
        },
        day: {
            today: 'dziś',
            tomorrow: 'jutro',
            yesterday: 'wczoraj',
        },
        card: {
            failed: 'Nie udało się',
            taskAdded: 'Dodano zadanie',
            eventAdded: 'Dodano wydarzenie',
            allDayOn: '{day}, cały dzień',
            bedtimeSaved: 'Zapisano zaśnięcie',
            wakeUpSaved: 'Zapisano pobudkę',
            sleepSaved: 'Zapisano sen',
            bedtimeAt: 'zaśnięcie {time}',
            wakeUpAt: 'pobudka {time}',
            quality: 'jakość {quality}',
            noteSaved: 'Zapisano notatkę',
            reportSaved: 'Zapisano raport dnia',
            workoutToCheck: 'Trening do sprawdzenia',
            fillDetails: 'Uzupełnij szczegóły w formularzu',
            mealToCheck: 'Posiłek do sprawdzenia',
            shoppingToCheck: 'Zakupy do sprawdzenia: {n} pozycja | Zakupy do sprawdzenia: {n} pozycje | Zakupy do sprawdzenia: {n} pozycji',
            shoppingNothing: 'Nie rozpoznano nic do kupienia',
            entrySaved: 'Wpis zapisany',
            mealAdded: 'Dodano posiłek',
            workoutAdded: 'Dodano trening',
            increased: '{n} doliczone do pozycji na liście',
            newProducts: 'nowe produkty: {list}',
            shoppingAdded: 'Dodano do zakupów: {n} pozycja | Dodano do zakupów: {n} pozycje | Dodano do zakupów: {n} pozycji',
            shoppingSkipped: 'Pominięto zakupy',
            corrected: 'Poprawiono',
            deleted: 'Usunięto',
            undone: 'Cofnięto: {what}',
            what: {
                task: 'zadanie',
                event: 'wydarzenie',
                note: 'notatkę',
                daily: 'raport dnia',
            },
            undoFailed: 'Nie udało się cofnąć',
        },
        sections: {
            saved: 'Zapisane',
            pending: 'Do potwierdzenia',
            failed: 'Nie udało się',
            other: 'Cofnięte i pominięte',
        },
        eyebrow: {
            welcome: 'Witaj w Rountine',
            shopping: 'Dyktowanie zakupów',
            dictation: 'Dyktowanie',
        },
        heading: {
            reviewShopping: 'Sprawdź zakupy',
            welcomeDone: 'Twój dzień się układa',
            results: 'Co się wydarzyło',
            welcome: 'Co masz dziś w planach?',
            shopping: 'Powiedz, co kupić',
            add: 'Powiedz, co dodać',
        },
        actions: {
            retry: 'Wyślij ten fragment jeszcze raz',
            review: 'Sprawdź',
            correct: 'Popraw',
            edit: 'Edytuj',
            undo: 'Cofnij',
        },
        links: {
            basket: 'Koszyk',
            shoppingList: 'Lista zakupowa',
            notes: 'Notatnik',
            planner: 'Zobacz w planerze',
        },
        welcomeIntro: 'Powiedz albo wpisz kilka rzeczy naraz — spotkania, zadania, trening, zakupy. Asystent rozdzieli je na wpisy i ułoży w planerze, a każdy poprawisz albo cofniesz.',
        welcomeExample: 'Dziś o 18 trening, o 20 kolacja z Olą, zadzwonić do mamy i kupić mleko',
        textPlaceholder: 'Tu pojawi się rozpoznany tekst — możesz go poprawić…',
        textPlaceholderManual: 'Wpisz tekst ręcznie…',
        exampleHint: 'Na przykład — kliknij, żeby wstawić',
        quoted: '„{text}"',
        basketSubtitle: 'Z dyktowania — odznacz to, czego nie potrzebujesz.',
        shoppingHint: 'np. „Mleko, dwa kilo ziemniaków, pesto na cztery porcje, składniki na leczo i worki na śmieci". Przed dodaniem zobaczysz podgląd.',
        whatYouCanRecord: 'Co możesz nagrać',
        saveAuto: 'Zapisze się od razu.',
        saveConfirm: 'Otworzy się formularz do sprawdzenia przed zapisem.',
        examplesHint: 'Przykłady — kliknij, żeby wstawić',
        whatYouCanSay: 'Co możesz powiedzieć',
        defaultValue: '(domyślnie: {value})',
        hideDetails: 'Ukryj szczegóły',
        details: 'Szczegóły',
        multiHint: 'W jednym nagraniu możesz powiedzieć kilka rzeczy, np. dwa wydarzenia i zakupy. Czas („wczoraj", „o 7") liczy się od teraz.',
        plannedHint: 'Wkrótce: {list} — na razie takie nagranie trafi do raportu dnia.',
        fallbackHint: 'np. „Zjadłem owsiankę z bananem na śniadanie" albo „Przebiegłem 5 km w 28 minut".',
        recordAnother: 'Nagraj kolejne',
        done: 'Gotowe',
        recording: 'Nagrywam {time}',
        status: {
            transcribing: 'Rozpoznaję nagranie…',
            listening: 'Słucham… mów',
            serverPhone: 'Dotknij, powiedz i dotknij stop',
            server: 'Kliknij, powiedz i kliknij stop',
            browserPhone: 'Dotknij i mów',
            browser: 'Kliknij i mów',
            unavailable: 'Nagrywanie niedostępne — wpisz tekst',
        },
        maxLength: 'Maks. {min} min — nagranie zatrzyma się samo.',
        addManually: 'Dodam ręcznie',
        cancel: 'Anuluj',
        stop: 'Zatrzymaj',
        stopRecording: 'Zatrzymaj nagrywanie',
        record: 'Nagrywaj',
        send: 'Wyślij',
    },
};
